export const BUTTON_PRIMARY_TYPE = 'primary';
export const BUTTON_SECONDARY_TYPE = 'secondary';
export const BUTTON_MODAL_TYPE = 'modal';

export const BUTTON_TYPES = [BUTTON_PRIMARY_TYPE, BUTTON_SECONDARY_TYPE, BUTTON_MODAL_TYPE];
